module.exports = __webpack_public_path__ + "712a32707f76e65684282682f81c9f4a.pdf";